import { getAssignmentColor } from '@oberoninternal/travelbase-ds/constants/theme';
import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

/**
 * TODO: Migrate this to the designsystem
 */
const Anchor = styled.button.attrs(({ as, type }: { as?: unknown; type?: string }) => ({
    type: as ? type : 'button',
}))<SpaceProps>`
    color: ${({ theme }) => getAssignmentColor(theme, theme.colorAssignments.textAction)} !important;
    text-decoration: none;
    text-align: start;
    text-underline-offset: 3px;
    padding: 0;
    margin: 0;
    font: inherit;
    font-weight: 500;
    cursor: pointer;

    :hover {
        text-decoration: underline !important;
        color: ${({ theme }) => getAssignmentColor(theme, theme.colorAssignments.textAction, 1)} !important;
    }
    ${space};
`;

export default Anchor;
